/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function e(e,a){const c=e.featureReduction;return c&&"selection"!==c.type&&(!("maxScale"in c)||!c.maxScale||c.maxScale<a.scale)?c:null}export{e as getEffectiveFeatureReduction};
